import React from 'react';

const DragHandleIcon = () => {
  return (
    <svg className="drag-handle-icon" width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
      <title>Drag Handle Icon</title>
      <defs />
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-294.000000, -585.000000)" fill="currentColor">
          <g transform="translate(255.000000, 244.000000)">
            <g transform="translate(0.000000, 146.000000)">
              <g transform="translate(25.000000, 157.000000)">
                <g transform="translate(0.000000, 24.000000)">
                  <g transform="translate(14.000000, 14.000000)">
                    <circle cx="1" cy="1" r="1" />
                    <circle cx="1" cy="6" r="1" />
                    <circle cx="1" cy="11" r="1" />
                    <circle cx="6" cy="1" r="1" />
                    <circle cx="6" cy="6" r="1" />
                    <circle cx="6" cy="11" r="1" />
                    <circle cx="11" cy="1" r="1" />
                    <circle cx="11" cy="6" r="1" />
                    <circle cx="11" cy="11" r="1" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DragHandleIcon;
